import { Form as Forms } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import AntdSelect from 'components/Form/Select'
import SelectShort from 'components/Form/SelectShort'
import RangeSliderInput from 'components/RangeSliderInput'
import CheckIcon from 'components/icons/CheckIcon'
import DoubleArrowIcon from 'components/icons/DoubleArrowIcon'
import DepartmentAndSpecialization from 'modules/Courses/Partials/AddCourseDrawer/DepartmentComponent/index'
import {
  FooterFlex,
  Form,
  StyledDrawer,
} from 'modules/Courses/Partials/AddCourseDrawer/Style/style'
import { dropDownValues, getDegreeData } from 'modules/Courses/actions'
import {
  FormItem,
  RadioGroup,
  StyledRadio,
} from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

const StyledFormItem = styled(Form.Item)`
  &.ant-form-item-has-error .ant-form-item-explain {
    position: relative;
    top: 10px;
  }

  .ant-form-item-control-input {
    min-height: 0px !important;
  }
`
const TwoFields = styled(Flex)`
  gap: 20px;
`

const AddCourseDrawer = ({
  addCourse,
  setAddCourse,
  createEditForm,
  formId = 'course_form',
  title = 'Add New Course',
  sendButtonText = 'Save Course',
  AddMultiCourses,
  specialisationId,
  setDegreeStreamMapId,
  submitClose,
  isEditing,
  courseId,
  EditCourses,
  listOfStudentSkills,
  queryParam,
  degreeStreamMapId,
  cruds,
  getCoursesList,
  setEditCourse,
  editCourse,
  isEditable,
  degreeId,
  delayToFetchSkill,
  getFilterDegreeData,
}) => {
  const addReason = Forms.useWatch('type', createEditForm)
  const formRef = React.createRef()
  const { DEGREE_STREAM_MAP_ID_MBA } = process.env
  const { DEGREE_STREAM_MAP_ID_PGDM } = process.env
  const dispatch = useDispatch()
  const skillList = useSelector(state => state?.courses?.skillList)
  const [selectedSkill, setSelectedSkill] = useState([])
  const [degreeList, setDegreeList] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [specialisationList, setSpecialisationList] = useState([])
  const [showSpecialization, setShowSpecialization] = useState(false)
  const [finalOutput, setFinalOutputs] = useState([])
  const [checkListCount, setCheckListCount] = useState(0)
  const [specialisationCount, setSpecialisationCount] = useState(0)
  const [departmentValue, setDepartmentValue] = useState([])
  const [specializationValue, setSpecializationValue] = useState([])
  const [isElementVisible, setIsElementVisible] = useState(false)
  const [depList, setDepList] = useState([])
  const [checkedList, setCheckedList] = useState(defaultCheckedList)
  const defaultCheckedList = departmentValue
  const [specialisationName, setSpecializationName] = useState('')
  const [departmentName, setDepartmentName] = useState('')
  const [domainName, setDomainName] = useState('')
  const [depName, setDepName] = useState('')
  const [specialisationsName, setSpecialisationsName] = useState([])
  const [isSpecialisationTouched, setIsSpecialisationTouched] = useState(false)
  const [specialisationSelectList, setSpecialisationSelectList] = useState(
    createEditForm.getFieldValue([`specialisation`]) ?? []
  )
  const [loading, setLoading] = useState(false)
  const setFinalOutput = data => {
    setFinalOutputs(data)
  }
  const mappedSpecialisation = true

  const [degreeSearch, setDegreeSeach] = useState('')
  const [domainValues, setDomainValues] = useState([])
  const [domainCruds, setDomainCruds] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dropDownValues({ url: 'crud/domains?status=1' })
        setDomainCruds(response.data.result)
      } catch (error) {
        console.error('Error fetching domain values:', error)
      }
    }
    fetchData()
  }, [])

  const onDomainChange = (data = '', option) => {
    createEditForm.setFieldsValue({ domainName: data })
    let copyofDomainValues = [...domainValues]
    let domain = copyofDomainValues?.find(value => value.id == data)
    gettingData(domain ? domain?.id : '')
    if (option === undefined) {
      createEditForm.setFieldsValue({ degreeName: '' })
    }
  }

  useEffect(() => {
    if (isEditing) setIsElementVisible(false)
    gettingData()
  }, [isEditing])

  const onDegreeChange = (data, option) => {
    setCheckedList([]);             
    setCheckListCount(0);           
    setDepartmentValue([]);         
    setDepList([]);
    setDepartmentList([])                
    if (option?.option?.name?.toLowerCase() === 'master of business administration') {
      setDepList([DEGREE_STREAM_MAP_ID_MBA])
      setCheckedList([DEGREE_STREAM_MAP_ID_MBA])
      setDepartmentValue([DEGREE_STREAM_MAP_ID_MBA])
      setDepartmentName('Management')
      setIsElementVisible(true)

    }
    if (option?.option?.name?.toLowerCase() === 'post graduate diploma in management') {
      setDepList([DEGREE_STREAM_MAP_ID_PGDM])
      setCheckedList([DEGREE_STREAM_MAP_ID_PGDM])
      setDepartmentValue([DEGREE_STREAM_MAP_ID_PGDM])
      setDepartmentName('Management')
      setIsElementVisible(true)

    }
    let firstDepartment = option?.option?.degreeStreamMap?.[0]

    createEditForm.setFieldsValue({ examtype: firstDepartment?.examType })
    createEditForm.setFieldsValue({ duration: firstDepartment?.duration })
    createEditForm.setFieldsValue({ suffix: option?.option?.shortForm })
    createEditForm.setFieldsValue({ departmentName: '' })

    createEditForm.setFieldsValue({ degreeName: data })
    let updatedList = option?.option?.degreeStreamMap?.map(
      ({ id, duration, examType, stream }) => {
        return { ...stream, duration, examType, id }
      }
    )
    setSpecialisationList([])
    createEditForm.setFieldsValue({ specialisation: '' })
    setSpecialisationSelectList([])
    setSpecialisationCount(0)
    setSpecialisationsName([])
    setDepartmentList(updatedList)
    setSpecialisationCount(0)
    setSpecializationValue([])
    setDepartmentValue([])
  }
  const onDepartmentChange = (data, option) => {
    setSpecialisationList([])
    setSpecializationName([])
    setSpecialisationCount(0)
    createEditForm.setFieldsValue({ examtype: option?.option?.examType })
    createEditForm.setFieldsValue({ duration: option?.option?.duration })
    createEditForm.setFieldsValue({ specialisation: '' })
    setSpecialisationSelectList([])
    createEditForm.setFieldsValue({ departmentName: data })
    setDegreeStreamMapId(option?.option?.id)
    let specialisation = option?.option?.specialisation
    setSpecialisationList(specialisation)
    if (option?.option?.specialisation?.length) {
      setShowSpecialization(true)
    } else {
      setShowSpecialization(false)
    }
  }
  useEffect(() => {
    if (checkListCount > 0) {
      formRef.current.setFields([
        {
          name: 'Department',
          errors: [''],
        },
      ])
    }
  }, [checkListCount])

  useEffect(() => {
    if (isEditing) gettingData()
  }, [])

  useEffect(() => {
    if (createEditForm.getFieldValue(['skills'])) {
      setSelectedSkill(createEditForm.getFieldValue(['skills']))
    }
    if (createEditForm.getFieldValue(['specialisation'])) {
      setShowSpecialization(true)
    }
  }, [])

  const addedSkill = value => {
    createEditForm.setFieldsValue({
      skills: value,
    })
    setSelectedSkill(value)
  }

  useEffect(() => {
    let degreename = createEditForm.getFieldValue(['degreeName'])

    let list = degreeList?.result?.filter(data => data?.name === degreename)
    let updatedList =
      list &&
      list[0]?.degreeStreamMap?.map(({ id, duration, examType, stream }) => {
        return { ...stream, duration, examType, id }
      })
    setDepartmentList(updatedList || [])
  }, [degreeList])
  useEffect(() => {
    if (departmentName) {
      createEditForm.setFieldsValue({
        departmentName: departmentName,
      })
    } else {
    }
  }, [departmentName, checkListCount, departmentList])
  useEffect(() => {
    if (specialisationCount) {
      setSpecialisationSelectList([
        specialisationName + '(' + specialisationCount + ')',
      ])
      createEditForm.setFieldsValue({
        specialisation: specialisationName + '(' + specialisationCount + ')',
      })
    } else {
    }
  }, [departmentName, specialisationCount, departmentList])
  useEffect(() => {
    let deparmentName = createEditForm.getFieldValue(['departmentName'])
    let list = departmentList?.filter(data => data?.name === deparmentName)
    const upperCaseSpecializations = list?.[0]?.specialisation?.map(spec => ({
      ...spec,
      name: spec.name?.toUpperCase()
    })) || []
    setSpecialisationList(upperCaseSpecializations)
  }, [departmentList])

  const gettingData = async domainId => {
    const selectedType = createEditForm.getFieldValue(['type'])
    console.log('=== gettingData called ===');
    console.log('selectedType:', selectedType);
    console.log('domainId:', domainId);
    console.log('mappedSpecialisation:', mappedSpecialisation);
    
    let data = await dispatch(
      getDegreeData('', selectedType, domainId, mappedSpecialisation)
    )
    
    console.log('API response data:', data);
    
    // Don't filter degrees based on selectedType since the API already filters by degreeType
    // The filtering was causing issues for PG Diploma
    
    if (!domainId) {
      let domainIds = data?.result?.map(data => data?.domainId) || []
      console.log('domainIds from API:', domainIds);
      console.log('domainCruds available:', domainCruds);
      
      if (domainIds.length > 0 && domainCruds?.length) {
        let domains = domainCruds.filter(
          domain => domain.id && domainIds.includes(domain.id)
        )
        console.log('filtered domains:', domains);
        setDomainValues(domains)
      } else {
        console.log('No domains found or domainCruds empty');
        setDomainValues([])
      }
    }
    setDegreeList(data)
  }
  useEffect(() => {
    let degreename = createEditForm.getFieldValue(['degreeName'])
    let list = degreeList?.result?.filter(data => data?.id === degreeId)
    let updatedList =
      list &&
      list[0]?.degreeStreamMap?.map(({ id, duration, examType, stream }) => {
        return { ...stream, duration, examType, id }
      })
    setDepartmentList(updatedList || [])
  }, [degreeList, degreeId])
  const onChangeType = e => {
    console.log('=== onChangeType called ===');
    console.log('Selected type:', e.target.value);
    
    createEditForm.setFieldsValue({ departmentName: '' })
    createEditForm.setFieldsValue({ domainName: '' })
    setCheckListCount(0)
    setSpecialisationCount(0)
    setSpecializationValue([])
    setSpecializationName([])
    setSpecialisationCount(0)
    setIsElementVisible(false)
    setSpecialisationSelectList([])
    createEditForm.setFieldsValue({ degreeName: '' })
    createEditForm.setFieldsValue({
      specialisation: '',
    })
    createEditForm.setFieldsValue({
      type: e.target.value,
    })
    
    // Clear existing degree list and department list
    setDegreeList({ result: [] })
    setDepartmentList([])
    setSpecialisationList([])
    setDomainValues([])
    
    // Fetch new data based on selected type
    console.log('Calling gettingData after type change...');
    gettingData()
  }
  useEffect(() => {
    if (depList?.length > 0) {
      let Filter = depList?.filter(item => checkedList?.includes(item.id))
      let checkSpecialisation = Filter?.map(item =>
        item?.specialisation?.filter(item => item?.checked == true)
      )
      let specialisationList = checkSpecialisation?.flat()

      let countSpecilasiationList = specialisationList?.length
      let specialisationName = specialisationList?.find(
        item => item?.checked == true
      )

      createEditForm.setFieldsValue({
        specialisation: `Specialization (${countSpecilasiationList})`,
      })
      setSpecialisationSelectList([
        `Specialization (${countSpecilasiationList})`,
      ])
    }
    formRef?.current?.setFields([
      {
        name: 'Department',
        errors: [''],
      },
    ])
  }, [depList])

  const submitHandler = async values => {
    if (isEditing && !isSpecialisationTouched) return submitClose()
    setAction(true)
    let Filter = depList?.filter(item => checkedList?.includes(item.id))
    const filteredA = Filter?.map(obj => {
      return {
        degreeStreamMapId: obj?.id,
        specialisation: obj?.specialisation?.filter(
          specObj => specObj?.checked === true
        ),
      }
    })
    let trimSkills =
      values?.skills && Array.isArray(values?.skills)
        ? values?.skills.filter(s => s.trim())
        : []
    const departmentAndSpecialisation = filteredA?.map(item => {
      return {
        degreeStreamMapId: item.degreeStreamMapId,
        ancillaryMainSkills: trimSkills,
        specialisations: item?.specialisation?.map(data => {
          return {
            specialisationId: data?.id,
          }
        }),
      }
    })

    let data = [
      {
        degreeStreamMapId: degreeStreamMapId,
        specialisations: specialisationsName,
      },
    ]
    if (trimSkills) {
      data[0].ancillaryMainSkills = trimSkills
    }

    if (!specialisationId) {
      delete data?.specialisations
    }
    if (isEditing) {
      await EditCourses(courseId, data[0])
      setEditCourse(true)
    }
    if (departmentAndSpecialisation?.length > 0) {
      if (isEditing) {
        if (departmentAndSpecialisation[0])
          await EditCourses(courseId, departmentAndSpecialisation[0])
      } else {
        const createdCourse = await AddMultiCourses(departmentAndSpecialisation)
        if (!createdCourse) return
      }
      createEditForm.resetFields()
      submitClose()
    } else {
      formRef?.current?.setFields([
        {
          name: 'Department',
          errors: ['Please Select Department!'],
        },
      ])
      return
    }
    let page = 0

    getCoursesList({ page, setLoading })
    let query = 'getAllCourses=true'
    getFilterDegreeData(query)
  }

  const [action, setAction] = useState(false)

  const hideElement = data => {
    setIsElementVisible(false)
    setAction(true)
    setDepartmentValue(data)
    setSpecializationValue(data)
    setDepartmentName(data)
  }
  const inputClick = () => {
    setIsElementVisible(true)
    setAction(false)
  }
  const onSpecialisationChange = (data, option) => {
    setIsSpecialisationTouched(true) 
    createEditForm.setFieldsValue({ specialisation: data })
    setSpecialisationSelectList(data)
    let id = option.map(item => {
      let specialisationId = {
        specialisationId: item.id,
      }
      return specialisationId
    })
    setSpecialisationsName(id)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = await dispatch(
          getDegreeData(
            degreeSearch,
            createEditForm.getFieldValue(['type']),
            createEditForm.getFieldValue(['domainName']),
            mappedSpecialisation
          )
        )
        setDegreeList(data)
      } catch (error) {
        console.error('Error fetching degree data:', error)
      }
    }

    fetchData()
  }, [degreeSearch])

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const delayToFetchDegree = useCallback(
    debounce(data => {
      setDegreeSeach(data)
    }, 500),
    []
  )
  const drawerTitle = isEditing ? 'View Course' : 'Add New Course'
  const content = () => {
    return (
      <div>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={formId}
          form={createEditForm}
          ref={formRef}
          layout="vertical"
        >
          <div>
            <Label required={true}>
              Type <span>*</span>
            </Label>

            <FormItem
              name="type"
              rules={[
                {
                  required: true,
                  message: 'Please Choose any type!',
                },
              ]}
            >
              <RadioGroup onChange={onChangeType} disabled={isEditing}>
                <StyledRadio
                  boxed={true}
                  value={'UG'}
                  label="Under Graduate(UG)"
                />
                <StyledRadio
                  boxed={true}
                  value={'PG'}
                  label="Post Graduate(PG)"
                />
                <StyledRadio
                  boxed={true}
                  value={'PHD'}
                  label="Doctorate(Phd)"
                />
                <StyledRadio boxed={true} value={'DIPLOMA'} label="Diploma" />
                <StyledRadio
                  boxed={true}
                  value={'P_G_DIPLOMA'}
                  label="PG Diploma"
                />
              </RadioGroup>
            </FormItem>
          </div>
          <AntdSelect
            name={'domainName'}
            label={'Domain'}
            placeholder="Arts"
            OptionData={domainValues}
            valueParam="id"
            nameParam="name"
            onChange={onDomainChange}
            disabled={!createEditForm.getFieldValue(['type']) || isEditing}
            value={createEditForm.getFieldValue(['domainName'])}
            showSearch={true}
            allowClear={true}
            filterOption={(inputValue, option) =>
              option?.name
                ?.toLowerCase()
                ?.indexOf(inputValue?.toLowerCase()) !== -1
            }
            style={{ width: '100%' }}                    
            dropdownStyle={{ maxWidth: '400px' }}        
            getPopupContainer={trigger => trigger.parentElement}
          />
          {isEditing && (
            <div>
              <TwoFields spaceBetween>
                <SelectShort
                  allowClear={true}
                  label="Degree"
                  placeholder="Eg. Bachelor of Engineering"
                  name={'degreeName'}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter degree!',
                    },
                  ]}
                  OptionData={
                    degreeList?.result?.filter(
                      option => option?.status.toString() === '1'
                    ) || []
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onDegreeChange}
                  value={createEditForm.getFieldValue(['degreeName'])}
                  showSearch={true}
                  disabled={
                    !createEditForm.getFieldValue(['type']) || isEditing
                  }
                  shortForm={true}
                  onSearch={data => delayToFetchDegree(data)}
                  isKey={true}
                />
              </TwoFields>
              <br></br>
              <AntdSelect
                label={'Department'}
                placeholder="Department"
                name={'departmentName'}
                rules={[
                  {
                    required: true,
                    message: 'Please select department!',
                  },
                ]}
                OptionData={departmentList?.filter(
                  option => option?.status.toString() === '1'
                )}
                valueParam="name"
                nameParam="name"
                onChange={onDepartmentChange}
                value={createEditForm.getFieldValue(['departmentName'])}
                showSearch={true}
                disabled={
                  !createEditForm.getFieldValue(['degreeName']) || isEditing
                }
              />
              <br></br>
              <div>
                <SelectShort
                  label={'specialisation'}
                  placeholder="specialisation"
                  name={'specialisation'}
                  OptionData={specialisationList}
                  valueParam="name"
                  nameParam="name"
                  onChange={onSpecialisationChange}
                  value={specialisationSelectList}
                  showSearch={true}
                  mode="multiple"
                  isKey={true}
                // disabled={isEditing}
                />
              </div>
            </div>
          )}
          {!isEditing && (
            <>
              <div>
                <Label required={true}>
                  Degree (or) Diploma / Department / Specialization{' '}
                  <span>*</span>
                </Label>
                <div
                  style={{
                    border: '1px solid #e8e8e8',
                    borderRadius: '10px',
                    width: '100%',
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                >
                  <SelectShort
                    allowClear={true}
                    placeholder="Degree"
                    name={'degreeName'}
                    style={{ width: '30%' }}
                    OptionData={
                      degreeList?.result?.filter(
                        option => option?.status.toString() === '1'
                      ) || []
                    }
                    valueParam="name"
                    nameParam="name"
                    onChange={onDegreeChange}
                    value={createEditForm.getFieldValue(['degreeName'])}
                    showSearch={true}
                    disabled={
                      !createEditForm.getFieldValue(['type']) ? true : false
                    }
                    shortForm={true}
                    onSearch={data => delayToFetchDegree(data)}
                    filterOption={false}
                    isKey={true}
                    isFullWidth={false}
                  />
                  <Button
                    style={{
                      width: '23px',
                      height: ' 23px',
                      border: 'none',
                      background: '#EBECEE',
                      borderRadius: '7px',
                    }}
                    icon={
                      <DoubleArrowIcon
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginBottom: '10px',
                        }}
                      />
                    }
                  />
                  <StyledFormItem name="Department">
                    <Input
                      placeholder={'Department(' + checkListCount + ')'}
                      style={{
                        background: ' #EBECEE',
                        borderRadius: '7px',
                        cursor: 'pointer',
                        marginTop: '23px',
                      }}
                      width="100%"
                      onClick={inputClick}
                      OptionData={departmentList?.filter(
                        option => option?.status.toString() === '1'
                      )}
                      readOnly 
                      valueParam="name"
                      nameParam="name"
                      onChange={onDepartmentChange}
                      disabled={
                        !createEditForm.getFieldValue(['degreeName'])
                          ? true
                          : false
                      }
                      value={
                        checkListCount && depName
                          ? 'Department' + ' ' + '( ' + checkListCount + ' )'
                          : ''
                      }
                      showSearch={false}
                    />{' '}
                  </StyledFormItem>
                  <Button
                    style={{
                      width: '23px',
                      height: ' 23px',
                      border: 'none',
                      background: '#EBECEE',
                      borderRadius: '7px',
                    }}
                    icon={
                      <DoubleArrowIcon
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginBottom: '10px',
                        }}
                      />
                    }
                  />
                  <Input
                    placeholder={`Specialization (${specialisationList?.length})`}
                    style={{ background: ' #EBECEE', borderRadius: '7px' }}
                    width="27%"
                    name={'specialisation'}
                    showSearch={true}
                    disabled={
                  true
                    }
                  />
                </div>
                <StyledFormItem
                  name="degreeName"
                  rules={[
                    {
                      required: true,
                      message: 'Please select degree!',
                    },
                  ]}
                >
                  <div> </div>{' '}
                </StyledFormItem>
              </div>
            </>
          )}
          {isElementVisible && (
            <div>
              <DepartmentAndSpecialization
                hideElement={hideElement}
                checkedList={checkedList}
                setCheckListCount={setCheckListCount}
                setSpecialisationCount={setSpecialisationCount}
                departmentList={departmentList}
                setFinalOutput={setFinalOutput}
                action={action}
                setAction={setAction}
                departmentValue={departmentValue}
                setDepartmentValue={setDepartmentValue}
                setSpecializationValue={setSpecializationValue}
                specializationValue={specializationValue}
                setDepartmentName={setDepartmentName}
                deparmentName={departmentName}
                setSpecializationName={setSpecializationName}
                specializationName={specialisationName}
                carryParam={queryParam}
                isEditing={isEditing}
                depList={depList}
                setDepList={setDepList}
                defaultCheckedList={defaultCheckedList}
                setCheckedList={setCheckedList}
                setDepName={setDepName}
                depName={depName}
                setSpecialisationList={setSpecialisationList}
                addedSkill={addedSkill}
              />
            </div>
          )}

          <div>
            <Label required={true}>
              Course Duration <span>*</span>
            </Label>

            <RangeSliderInput
              name={'duration'}
              label={' Year'}
              min={0}
              max={6}
              inputValue={createEditForm.getFieldValue(['duration'])}
              disabled={true}
            />
          </div>

          <div>
            <Label required={true}>
              Exam Type <span>*</span>
            </Label>

            <FormItem name="examtype">
              <RadioGroup disabled={true}>
                <StyledRadio boxed={true} value={'SEMESTER'} label="Semester" />
                <StyledRadio
                  boxed={true}
                  value={'TRISEMESTER'}
                  label="Trimester"
                />
                <StyledRadio boxed={true} value={'ANNUAL'} label="Annual" />
              </RadioGroup>
            </FormItem>
          </div>
        </Form>
      </div>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setAddCourse(false)
          }}
        />
        {(cruds?.includes('UPDATE') || cruds?.includes('NEW COURSES')) &&
          (
            <Button.Primary
              htmlType="submit"
              form={formId}
              text={sendButtonText}
              icon={<CheckIcon />}
            />
          )}
      </FooterFlex>
    )
  }
  return (
    <>
      <StyledDrawer
        width={'50%'}
        title={drawerTitle}
        placement="right"
        closable={true}
        onClose={() => {
          setAddCourse(false)
        }}
        visible={addCourse}
        content={content()}
        footer={footer()}
      />
    </>
  )
}

export default AddCourseDrawer
